//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { setting_obj } from '~/settings/setting';
import { needXssKeys } from '~/utils/constants';
import { replaceToOriginStr, formatPath} from '~/utils/tools';
import { handlePraise, downloadApi } from '@/utils/userTools';
import { handleUserBehaviorByType } from "@/components/subscription/subscription.js";
import LazyLoad from '../lazy-load'

const statusObj = {
  1: {
    text: '审核中',
    class: 'processing',
  },
  2: {
    text: '审核未通过',
    class: 'failed',
  },
};
export default {
  components: {LazyLoad},
  props: {
    cardType: {
      type: String,
      default: 'feed',
    },
    showMask: {
      type: Boolean,
      default: false,
    },
    pluginInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    action_position: {
      type: String,
      validator(value) {
        // 这个值必须匹配下列字符串中的一个
        return ['plugin_community', 'profile', 'banner', 'morelikethis', 'plugin_popup'].indexOf(value) !== -1;
      },
      default: 'community',
    },
    action_type: {
      type: String,
      default: '',
    },
    action_detail: {
      type: Number,
    },
    useOld: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      imageCdnPath: setting_obj.imageCdnPath,
      btnJump: false,
      favorite: false,
      favoriteCount: 0,
      isInstall: false,
      installCount: 0,
      pluginLoading: false,
    };
  },
  computed: {
    formatPluginInfo() {
      const info = { ...this.pluginInfo };
      const keys = Object.keys(info).filter((key) => needXssKeys.includes(key));
      ['plugin_logo', 'plugin_cover_url'].forEach((key) => {
        if (info[key]) {
          info[key] = formatPath(info[key], setting_obj.imageCdnPath);
        }
      });
      keys.forEach((key) => {
        if (!info[key]) return;
        if (Array.isArray(info[key])) {
          info[key] = info[key].map(replaceToOriginStr);
        } else if (typeof info[key] === 'string') {
          info[key] = replaceToOriginStr(info[key]);
        }
      });
      return info;
    },
    statusObj() {
      return statusObj[this.formatPluginInfo.status];
    },
    isShowView() {
      return this.formatPluginInfo.view_cnt || this.formatPluginInfo.install_cnt || !this.useOld;
    },
    isShowAuthor() {
      return this.cardType === 'feed';
    },
    disabled() {
      return this.isInstall;
    },
    installAllCount() {
      return (this.formatPluginInfo.install_cnt || 0) + this.installCount;
    },
    favoriteAllCount() {
      return (this.formatPluginInfo.like_cnt || 0) + this.favoriteCount;
    },
  },
  watch: {
    formatPluginInfo() {
      this.initInfo();
    },
  },
  created() {
    this.initInfo();
  },
  methods: {
    initInfo() {
      this.favorite = this.formatPluginInfo.favorite;
      this.favoriteCount = this.favorite && !this.formatPluginInfo.like_cnt ? 1 : 0;
      this.isInstall = this.formatPluginInfo.is_install;
      this.installCount = this.isInstall && !this.formatPluginInfo.install_cnt ? 1 : 0;
    },
    handleHover() {
      if (window.localStorage.getItem('CARD_HOVER') || this.useOld) return;
      window.localStorage.setItem('CARD_HOVER', '1');
      this.btnJump = true;
    },
    async handlePraise() {
      if (this.pending) return;
      this.pending = true;
      try {
        await handlePraise({
          res_id: this.formatPluginInfo.plugin_id,
          res_type: 1,
          action_type: this.favorite ? 2 : 1
        })
        this.favorite = !this.favorite;
        this.favoriteCount += this.favorite ? 1 : -1;
      } catch {
        //
      } finally {
        this.pending = false;
      }
    },
    goPluginDetail() {
      this.$emit('handelSubs');

      if (this.formatPluginInfo.status) return;
      if (this.action_position) {
        const sensorParams = {
          action_position: this.action_position,
          plugin_id: this.formatPluginInfo.plugin_id,
          plugin_name: this.formatPluginInfo.plugin_name,
          action_detail: this.action_detail,
        };
        if (this.action_type) {
          sensorParams.action_type = this.action_type;
        }
        // 根据来源增加访问社区文件埋点
        this.$sensors.track('get_plugin', sensorParams);
        const routeData = this.$router.resolve({
          name: 'plugin-id',
          params: { id: this.formatPluginInfo.plugin_id },
        });
        window.open(routeData.href, '_blank');
      }
    },
    download() {
      if (!this.formatPluginInfo?.plugin_id || this.isInstall || this.toInstall) return;
      this.toInstall = true;
      this.$sensors.track('install_plugin', {
        action_type: 'common',
        plugin_id: this.formatPluginInfo.plugin_id,
        plugin_name: this.formatPluginInfo.plugin_name,
        action_position: this.action_position,
      });
      this.pluginLoading = true;
      downloadApi(this.formatPluginInfo.plugin_id)
        .then(() => {
          handleUserBehaviorByType('plugin');
          this.isInstall = true;
          this.installCount++;
          this.toInstall = false;
          this.pluginLoading = false;
        })
        .catch(() => {
          this.toInstall = false;
          this.pluginLoading = false;
        });
    },
    goUser() {
      const routeData = this.$router.resolve({ name: 'profile-id', params: { id: this.formatPluginInfo.author_id } });
      window.open(routeData.href, '_blank');
    },
    clickResource(e) {
      if (this.showMask) e.preventDefault();
    },
  },
};
